import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ArrowSendIconHover from '../icons/ArrowSendIconHover';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import AddedIcon from '../icons/AddedIcon';

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function CardButton(props) {
  const classes = useStyles();

  const ColorButton = withStyles((theme) => ({
    root: {
      minWidth: 48,
      width: 48,
      margin: 0,
      padding: 0,
      // color: theme.palette.getContrastText(purple[500]),
      borderRadius: 48,
      height: 48,
      // boxShadow: '0px 6px 24px rgba(235, 80, 94, 0.4)',
      fontFamily: 'Cera CY',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '18px',
      lineheight: '23px',
      textTransform: 'none',
      color: props.color ? props.color : '#FFFFFF',
      backgroundColor: props.bgcolor,
      boxShadow: props.shadow,
      '&:hover': {
        backgroundColor: props.hbgcolor ? props.hbgcolor : props.bgcolor,
        boxShadow: props.hshadow ? props.hshadow : props.shadow,
      },
    },

    disabled: {
      color: props.hcolor ? props.hcolor : 'rgba(0, 0, 0, 0.26)',
      backgroundColor: props.disbgcolor ? props.disbgcolor : '#EEEEF5 !important'
    }
  }))(Button);

  return (
    <ColorButton
      // variant="contained"
      // color="primary"
      className={classes.margin}
      onClick={props.func ? props.func : ''}
      disabled={props.disabled}
    >
      {
        props.icon === 1
          ?
          <ArrowSendIconHover
            discolor={props.disabled ? '#b6b5c7' : null}
            onClick={props.func}
          />
          :
          <AddedIcon
            fill={'#3C3C56'}
          />
      }
    </ColorButton>
  );
}